import type { BuiltinComponents } from "@fingerprintjs/fingerprintjs";

export const DEFAULT_NONCE = "eeZei9ne";

export const DEFAULT_TIMER_INTERVAL = 1000;

export const DEFAULT_CONFIG: {
    components_dfp1: Array<keyof BuiltinComponents>;
    components_dfp2: Array<keyof BuiltinComponents>;
    nonce: string;
    pc_domain: string;
    pc_expire_minutes: number;
    pc_name: string;
} = {
    components_dfp1: [
        "colorDepth",
        "cpuClass",
        "deviceMemory",
        "fonts",
        "hardwareConcurrency",
        "indexedDB",
        "languages",
        "localStorage",
        "openDatabase",
        "platform",
        "plugins",
        "screenResolution",
        "sessionStorage",
        "touchSupport",
        "vendorFlavors",
        "cookiesEnabled",
        "vendor",
    ],
    components_dfp2: [
        "colorDepth",
        "cpuClass",
        "deviceMemory",
        "fonts",
        "hardwareConcurrency",
        "indexedDB",
        "languages",
        "localStorage",
        "openDatabase",
        "platform",
        "plugins",
        "screenResolution",
        "sessionStorage",
        "touchSupport",
        "vendorFlavors",
        "cookiesEnabled",
        "vendor",
        "canvas",
        "audio",
        "domBlockers",
        "fontPreferences",
        "screenFrame",
        "osCpu",
        "timezone",
        "colorGamut",
        "invertedColors",
        "forcedColors",
        "monochrome",
        "contrast",
        "reducedMotion",
        "hdr",
        "math",
    ],
    nonce: "eeZei9ne",
    pc_domain: "goodie.pl",
    pc_expire_minutes: 525600,
    pc_name: "_mmta",
};
